import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mmb-web-app-add-cv',
  templateUrl: './add-cv.component.html',
  styleUrls: ['./add-cv.component.scss']
})
export class AddCvComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
